import { ExpandMoreOutlined, Save } from "@mui/icons-material";
import {
  Add,
  Camera,
  CameraAltOutlined,
  CropOriginal,
  Delete,
  DeleteForever,
  DeleteOutline,
  Update,
} from "@mui/icons-material";
import * as EmailValidator from "email-validator";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Autocomplete,
  Box,
  Button,
  Chip,
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  TextField,
} from "@mui/material";
import React from "react";

import { format } from "date-fns";
import { useTheme } from "@emotion/react";
import { tokens } from "../../../Theme/theme";
import { useState } from "react";
import { useEffect } from "react";
import SnackbarComponent from "./SnackbarComponent";
import ModifyLocationdetails from "./ModifydataApi";
const ThirdRow = ({ data }) => {
  const theme = useTheme();

  const colors = tokens(theme.palette.mode);
  const [selectedColor, setSelectedColor] = useState("#000000");
  const [BuzzEnabled, setBuzzEnabled] = useState(true);
  const [LocationEmail, setLocationEmail] = useState("");
  const [buttonloading, setbuttonloading] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [severity, setseverity] = useState("success");
  const [AlertMessage, setAlertMessage] = useState("");
  const handleSnackbarClose = () => {
    setShowSnackbar(false);
  };
  const ModifyData = async () => {
    try {
      const response = await ModifyLocationdetails(
        data._id,
        localStorage.getItem("token"),
        {
          AccentColor: selectedColor,
          BuzzEnabled: BuzzEnabled,
          LocationEmail: LocationEmail,
        }
      );
      if (response.success === true) {
        setbuttonloading(false);
        setseverity("success");
        setAlertMessage("Data Saved Successfully");
        setShowSnackbar(true);
      }
      if (response.success === false) {
        setbuttonloading(false);
        setseverity("error");
        setAlertMessage("INTERNAL SERVER ERROR");
        setShowSnackbar(true);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handlebuzzenabled = (e) => {
    setBuzzEnabled(e.target.value);
    // setCategory(e.target.value);
  };
  const [LocationEmailError, setLocationEmailError] = useState(false);
  const handleEmailChange = (e) => {
    const { value } = e.target;
    setLocationEmail(value);
    if (EmailValidator.validate(value) === false) {
      setLocationEmailError(true);
      return false;
    }
    setLocationEmailError(false);
    return true;
  };

  function handleColorChange(event) {
    setSelectedColor(event.target.value);
    console.log("Selected color: " + event.target.value);
  }
  if (!data) {
    <Box>NOT GETTING DATA</Box>;
  }
  useEffect(() => {
    console.log(data);
    if (data) {
      setSelectedColor(data.AccentColor);
      setLocationEmail(data.LocationEmail);
      setBuzzEnabled(data.BuzzEnabled);
    }
  }, []);

  return (
    <Box>
      <Accordion sx={{ backgroundColor: colors.blueAccent[900] }}>
        <AccordionSummary
          expandIcon={<ExpandMoreOutlined />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          EMAIL,BUZZ ENABLED,ACCENT COLOR
        </AccordionSummary>
        <AccordionDetails>
          <Box
            display={"grid"}
            gridTemplateColumns="repeat(12,1fr)"
            gridAutoRows={"80px"}
            gap="20px"
          >
            <Box
              gridColumn={"span 4"}
              //   backgroundColor={colors.primary[400]}
              display="flex"
              alignItems={"center"}
              justifyContent="center"
            >
              <TextField
                // gridColumn="span 8"
                // gridRow="span 3"
                id=""
                label="EMAIL"
                error={LocationEmailError}
                helperText={LocationEmailError ? "Enter a valid Email" : null}
                //   color={colors.greenAccent[200]}
                //   fullWidth
                variant="standard"
                InputLabelProps={{
                  style: {
                    color: colors.blueAccent[800],
                    paddingLeft: 7,
                    fontWeight: "bold",
                  },
                }}
                sx={{
                  width: "100%",
                  backgroundColor: colors.grey[300],
                  input: { color: colors.grey[900], fontWeight: "bold", pl: 1 },
                  // borderRadius: "10%",
                }}
                value={LocationEmail}
                onChange={handleEmailChange}
              />
            </Box>
            <Box
              gridColumn={"span 4"}
              //   backgroundColor={colors.primary[400]}
              //   gridRow="span 3"
            >
              <FormControl
                variant="standard"
                sx={{
                  width: "100%",
                  marginTop: 2,
                  backgroundColor: colors.grey[300],
                  input: { color: colors.grey[900] },
                  color: colors.grey[900],
                }}
              >
                <InputLabel
                  sx={{
                    color: colors.blueAccent[800],
                    paddingLeft: 1,
                    fontWeight: "bold",
                  }}
                  id="demo-simple-select-standard-label"
                >
                  BUZZ ENABLED
                </InputLabel>
                <Select
                  labelStyle={{ color: "#ff0000" }}
                  sx={{
                    color: "white",
                    ".MuiSelect-select": {
                      color: colors.grey[900],
                      pl: 1,
                      fontWeight: "bold",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "rgba(228, 219, 233, 0.25)",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "rgba(228, 219, 233, 0.25)",
                    },
                    ".MuiSvgIcon-root ": {
                      fill: "white !important",
                    },
                  }}
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={BuzzEnabled}
                  // inputProps={{ input: {  } }}color: colors.grey[900]
                  onChange={handlebuzzenabled}
                  label="Age"
                  // error={CategoryError}
                >
                  <MenuItem value="">
                    <em>PLEASE SELECT FROM THE FOLLOWING</em>
                  </MenuItem>
                  <MenuItem value={true}>Yes</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box
              gridColumn={"span 4"}
              //   backgroundColor={colors.primary[400]}
              display="flex"
              alignItems={"center"}
              justifyContent="center"
            >
              <p style={{ padding: "12px" }}>
                Selected Accent Color:-{selectedColor}
              </p>
              <input
                style={{
                  // width: "100%",
                  height: "75%",
                  // marginTop: 2,
                  // backgroundColor: colors.grey[300],
                  // input: { color: colors.grey[900] },
                  // color: colors.grey[900],
                }}
                type="color"
                value={selectedColor}
                onChange={handleColorChange}
              />
            </Box>
          </Box>
          <Box pb={"10px"} display={"flex"} justifyContent="center">
            <Button
              disabled={buttonloading}
              startIcon={<Save />}
              style={{
                borderRadius: 12,
                backgroundColor: colors.greenAccent[500],
                // padding: "18px 36px",
                fontSize: "18px",
                height: "34px",
                marginBottom: "2px",
              }}
              variant="contained"
              component="label"
              onClick={ModifyData}
              //   disabled={false}
            >
              Save Changes
              {/* {buttonloading === true ? buttontext : "ADD THE LOCATION"} */}
              {/* <input hidden accept="image/*" multiple type="file" /> */}
            </Button>
          </Box>
        </AccordionDetails>
      </Accordion>
      {showSnackbar && (
        <SnackbarComponent
          open={true}
          severity={severity}
          AlertMessage={AlertMessage}
          onClose={handleSnackbarClose}
        />
      )}
    </Box>
  );
};

export default ThirdRow;
